var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.imageType !== 'cover' && _vm.imageType !== 'quoteAndPricingLogo')?_c('vue-anka-cropper',{attrs:{"options":{
           aspectRatio: 1800/200,
           closeOnSave: true,
           croppedHeight: 200,
           croppedWidth: 1800,
           dropareaMessage: 'Upload file or drag and drop',
           frameLineDash: [0,0],
           frameStrokeColor: 'rgba(255, 255, 255, 1.0)',
           handleFillColor: 'rgba(255, 255, 255, 1.0)',
           handleHoverFillColor: 'rgba(255, 255, 255, 1.0)',
           handleHoverStrokeColor: 'rgba(255, 255, 255, 1.0)',
           handleSize: 13,
           handleStrokeColor: 'rgba(255, 255, 255, 0.1)',
           overlayFill: 'rgba(0, 0, 0, 0.1)',
           previewOnDrag: true,
           selectButtonLabel: 'Select Files',
           showPreview: true,
           previewQuality: 1,
           resultQuality: 1,
           skin: 'light',
           uploadData: {
            type: _vm.imageType,
            proposalTemplateId: _vm.proposalTemplateId
            },
           uploadTo:_vm.uploadUrl
           }},on:{"cropper-saved":function($event){return _vm.savedAction(_vm.cropData)},"cropper-uploaded":function($event){return _vm.afterSavedAction(_vm.cropData)}}}):(_vm.imageType == 'quoteAndPricingLogo')?_c('vue-anka-cropper',{attrs:{"options":{
               aspectRatio: 640/534,
               closeOnSave: true,
               croppedHeight: 534,
               croppedWidth: 640,
               dropareaMessage: 'Upload file or drag and drop',
               frameLineDash: [0,0],
               frameStrokeColor: 'rgba(255, 255, 255, 1.0)',
               handleFillColor: 'rgba(255, 255, 255, 1.0)',
               handleHoverFillColor: 'rgba(255, 255, 255, 1.0)',
               handleHoverStrokeColor: 'rgba(255, 255, 255, 1.0)',
               handleSize: 13,
               handleStrokeColor: 'rgba(255, 255, 255, 0.1)',
               overlayFill: 'rgba(0, 0, 0, 0.1)',
               previewOnDrag: true,
               selectButtonLabel: 'Select Files',
               showPreview: true,
               previewQuality: 1,
               resultQuality: 1,
               skin: 'light',
               uploadData: {
                type: _vm.imageType,
                proposalTemplateId: _vm.proposalTemplateId
                },
               uploadTo:_vm.uploadUrl
        }},on:{"cropper-saved":function($event){return _vm.savedAction(_vm.cropData)},"cropper-uploaded":function($event){return _vm.afterSavedAction(_vm.cropData)}}}):_c('vue-anka-cropper',{attrs:{"options":{
           aspectRatio: false,
           closeOnSave: true,
           croppedHeight: false,
           croppedWidth: false,
           dropareaMessage: 'Upload file or drag and drop',
           frameLineDash: [0,0],
           frameStrokeColor: 'rgba(255, 255, 255, 1.0)',
           handleFillColor: 'rgba(255, 255, 255, 1.0)',
           handleHoverFillColor: 'rgba(255, 255, 255, 1.0)',
           handleHoverStrokeColor: 'rgba(255, 255, 255, 1.0)',
           handleSize: 13,
           handleStrokeColor: 'rgba(255, 255, 255, 0.1)',
           overlayFill: 'rgba(0, 0, 0, 0.1)',
           previewOnDrag: true,
           selectButtonLabel: 'Select Files',
           showPreview: true,
           previewQuality: 1,
           resultQuality: 1,
           skin: 'light',
           uploadData: {
            type: _vm.imageType,
            proposalTemplateId: _vm.proposalTemplateId
            },
           uploadTo:_vm.uploadUrl
           }},on:{"cropper-saved":function($event){return _vm.savedAction(_vm.cropData)},"cropper-uploaded":function($event){return _vm.afterSavedAction(_vm.cropData)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }